/* eslint-disable react-hooks/rules-of-hooks */
import React, {
  Fragment,
  useEffect,
  useState,
  useCallback,
  useMemo,
} from "react";
import { Marker, MapContainer, Polyline, TileLayer } from "react-leaflet";
import AddMarker from "./AddMarker";
import { useStyles } from "./Theme.js";
import { Button, Grid } from "@material-ui/core";
import gr107tracet from "../gr107tracet/File Attachment- CBH_GR107_Total_Set2020.gpx";
import L from "leaflet";
import gpxParser from "gpxparser";

import "leaflet-gpx";

//images

import geolocalisation from "../images/pictos-ok/GEOLOCALISATION.svg";
import entreruneadresse from "../images/pictos-ok/ENTRER-UNE ADRESSE.svg";

/*L.Marker.prototype.options.icon = L.icon({
  iconUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png",
});*/
const Geoloc = (props) => {
  const classes = useStyles();
  const [map, setMap] = useState(null);

  const [curseur, setcurseur] = useState(null);
  let newResult = useState(null);
  // let curseur = 0;
  useEffect(() => {
    // Quand le composant se charge, bloque la possibilité de passer sans répondre
    props.setAuthorization(false);
    let newResult = props.result;
    newResult["posicursor"] = "NOK";
    props.setResult(newResult);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * @description Fait remonter le résultat de la géoloc dans la réponse du formulaire
   * @description Autorise à poursuivre la navigation dans le formulaire
   * @param {number} latlng
   */
  const handleResponse = (latlng) => {
    // Insère les coordonnées dans la réponse
    let newResult = props.result;
    newResult["position"] = latlng;
    props.setResult(newResult);
    // Autorise à poursuivre le formulaire
    props.setAuthorization(true);
  };

  const posicursor = useCallback(() => {
    alert("Veuillez cliquez sur la carte pour positionner le curseur");
    newResult = props.result;
    newResult["posicursor"] = "OK";
    props.setResult(newResult);
    props.setAuthorization(true);
  });
  /**
   * @description Ajoute un nouveau marqueur sur la carte
   * @param {Map} map
   * @param {number} accuracy
   * @param {number} latlng
   */
  const newToken = (map, accuracy, latlng, curseur) => {
    const radius = accuracy;
    // Efface tous les autres tokens présents
    //deleteTokens(map);
    // Ajoute un marker sur la map
    L.marker(latlng)
      .addTo(map)
      .bindPopup("You are within " + radius + " meters from this point");
    // Ajoute un cercle sur la map autour du marker
    L.circle(latlng, radius).addTo(map);
  };

  /**
   * @description Efface tous les tokens présents sur la map, sauf le layer de base
   * @param {map} map La map leaflet préalablement générée
   */
  const deleteTokens = (map) => {
    const tokens = Object.values(map._panes);
    console.log(tokens);

    map._panes.markerPane.remove();
    for (let i = 1; i < tokens.length; i++) {
      map.removeLayer(tokens[i]);
    }
  };

  /**
   * @Description Retourne un Boutton MUI connecté avec la map Leaflet
   * @param {map} map La map leaflet préalablement générée
   * @returns void
   */

  const tablatling = [];
  function GeolocButton({ map }) {
    // Gère les évènements au clic du bouton
    const geoloc = useCallback(() => {
      // Localise l'utilisateur
      map.locate({ setView: true });
      // Se déclenche une fois la localisation trouvée
      map.on("locationfound", (event) => {
        //condition si c'est dans le tracé
        let latlngstring = event.latlng.lat + "-" + event.latlng.lng;
        //console.log(tablatling);
        if (!tablatling.includes(latlngstring)) {
          alert("Vous vous situez hors du chemin de randonnée");
        } else {
          map.setView(event.latlng);
        }
        handleResponse(event.latlng);
        newToken(map, event.accuracy, event.latlng);
      });
      // Se déclenche si la localision échoue
      map.on("locationerror", (event) => {
        alert(event.message);
      });
    }, [map]);

    return (
      <Button
        className={classes.themeButton2}
        onClick={geoloc}
        classes={{ label: "column textetakephoto" }}
      >
        <img src={geolocalisation} style={{ maxWidth: 40, marginBottom: 5 }} />
        Je me géolocalise
      </Button>
    );
  }

  function CursorButton({ map }) {
    // Gère les évènements au clic du bouton

    return (
      <Button
        className={classes.themeButton2}
        onClick={posicursor}
        classes={{ label: "column textetakephoto" }}
      >
        <img src={entreruneadresse} style={{ maxWidth: 40, marginBottom: 5 }} />
        Je positionne le curseur
      </Button>
    );
  }
  /**
   * @Description Permet d'afficher la map avec Leaflet
   */

  //const gpx = GPX.parse(gr107tracetstring);
  //console.log("TEST" + gr107tracetstring);
  //const positions = gpx.tracks[0].points.map((p) => [p.lat, p.lon]);

  const displayMap = useMemo(
    () => (
      <MapContainer
        center={[42.836407, 0.000301]}
        zoom={8}
        scrollWheelZoom={false}
        whenCreated={setMap}
        style={{ minHeight: "40vh", marginBottom: 20 }}
      >
        <TileLayer
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <AddMarker result={props.result} setResult={props.setResult} />
      </MapContainer>
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  if (map) {
    const gpx = gr107tracet;

    new L.GPX(gpx, { async: true, display_wpt: false })
      .on("loaded", function (e) {
        let tmpbounds = e.target.getBounds();
        let xmlDoc = e.element;
        let xmlstring = new XMLSerializer().serializeToString(
          xmlDoc.documentElement
        );
        let gpxnew = new gpxParser();
        gpxnew.parse(xmlstring);
        let trackspoint = gpxnew.tracks[0].points;

        for (const property in trackspoint) {
          tablatling.push(
            trackspoint[property].lat + "-" + trackspoint[property].lon
          );
        }

        map.setMaxBounds(tmpbounds);
        map.setZoom(8);
      })
      .addTo(map);
  }
  return (
    <Fragment>
      {displayMap}
      <Grid container spacing={2}>
        <Grid item xs={6}>
          {map ? <CursorButton map={map} curseur={curseur} /> : null}
        </Grid>
        <Grid item xs={6}>
          {map ? <GeolocButton map={map} /> : null}
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default Geoloc;
